import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "kebab-container" }
const _hoisted_2 = { class: "popup-actions" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("td", _mergeProps({ class: "text-center" }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        ref: "button",
        class: "kebab-btn",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, " ⋮ ", 512),
      _createVNode(_component_Popup, {
        show: _ctx.show,
        anchor: 'button',
        "anchor-align": { horizontal: 'right', vertical: 'bottom' },
        "popup-align": { horizontal: 'right', vertical: 'top' },
        collision: { horizontal: 'fit', vertical: 'flip' },
        animate: false,
        "popup-class": "kebab-popup"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localActions, (action) => {
              return (_openBlock(), _createElementBlock("div", {
                key: action.id,
                class: "action",
                onClick: _withModifiers(($event: any) => (_ctx.onClickAction(action)), ["stop"])
              }, _toDisplayString(action.text), 9, _hoisted_3))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 16))
}